module.exports = __webpack_public_path__ + "img/news-outline.03818e76.svg";